import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { APIV2_URL } from './constants';
import { PostUserKYCPayload, PostUserKYCRespond } from './types/Kyc';

export type PostUserKYC = (
  userId: 'me' | number,
  data: Partial<PostUserKYCPayload>,
) => Promise<{ data: PostUserKYCRespond }>;

export default (makeCall: MakeCall): PostUserKYC => (userId, data) =>
  makeCall<PostUserKYCRespond>('POST', `${APIV2_URL}/user/${userId}/kyc`, {
    data,
  });
